import React from 'react';
import withRouter from '../../with_router.js';


class GoogleCallback extends React.Component {
    async componentDidMount() {
        try {
            this.props.setLoading();
            const code = new URLSearchParams(this.props.location.search).get('code');
            if (!code) return this.props.history.replace('/login');

            // Exchange code for your own JWT
            const resp = await fetch(
                `${this.props.baseUrl}/auth/google`,
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ code, redirectUri: window.location.origin + '/signup/oauth2/callback' })
                }
            );
            // Handle response
            const response = await resp.json();
            const data = response.value.login_data;
            // Handle login
            this.props.unsetLoading();
            this.props.setLogin(true, data.id, data.email, data.token, "/", data.admin_role);
        } catch (error) {
            // Track error
            var name = "";
            var message = "Could not sign in. Please try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "GoogleCallback_componentDidMount");
            this.props.unsetLoading();
        }
    }

    render() { return <div className={"content-container content-wrapper content-wrapper--vertical-padding"}>Signing you in…</div>; }
}


export default withRouter(GoogleCallback);